export const CREDIT_REWARD_FOR_APP_USAGE = 15;
